<div class="flex flex-col items-stretch">
  <h4 matDialogTitle>Set up signature capture</h4>
  <div mat-dialog-content>
    <div class="flex flex-col items-stretch">
      <p>To collect signatures on another device, follow the steps below</p>
      <ol class="list-decimal ml-8 space-y-2 my-2">
        <li>
          On the device, open a web browser and go to this address:
          <code>{{ appUrl }}/counter</code>
        </li>
        <li>
          If prompted, enter your login details. You will then be redirected to
          the signature page.
        </li>
        <li>
          A 4 digit code will be shown on the screen, enter the code in the box
          below and press save.
        </li>
        <li>
          A signature box will appear on the device, hand it to the customer and
          ask them to sign it and press save.
        </li>
        <li>
          Press the refresh button in the top corner of the signatures section
          and the signature will appear in the list.
        </li>
      </ol>

      <mat-form-field class="my-2">
        <input matInput [formControl]="formControl" placeholder="Device Code" />
      </mat-form-field>
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button mat-flat-button matDialogClose>Cancel</button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="!formControl.valid"
      [matDialogClose]="formControl.value"
    >
      Save
    </button>
  </mat-dialog-actions>
</div>
